import React from 'react'
import { Box } from '../Styled'
import { FlexWrapper } from 'lib/ui/components/FlexWrapper'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { Customer } from 'lib/types/core'

interface Props {
  customer?: Customer
}

export const Contact: React.FC<Props> = ({ customer }) => (
  <Box>
    <FlexWrapper className='flex-box'>
      <h3>
        <FormattedMessage id='customer.account.dashboard.about.me' />
      </h3>
      <Link to='/customer/account/about' className='toRight'>
        <FormattedMessage id='customer.account.dashboard.edit' />
      </Link>
    </FlexWrapper>
    <div className='border-box'>
      <p><strong>{customer?.firstName} {customer?.lastName}</strong></p>
      <p>{customer?.email}</p>
      <p>Password: ******</p>
    </div>
  </Box>
)
